<script setup lang="ts">
import { ScheduleFieldsFragment, ScheduleItemFieldsFragment } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ScheduleFieldsFragment
}>()

const items =
  props.entity.fieldItems?.map((item) => {
    return {
      title: (item?.entity as ScheduleItemFieldsFragment).fieldTitle,
      text: (item?.entity as ScheduleItemFieldsFragment).fieldText?.processed,
      time: (item?.entity as ScheduleItemFieldsFragment).fieldStartTime,
    }
  }) || []
</script>

<template>
  <Section>
    <div class="t-10 t-o-1 tl-7 tl-o-0 ds-o-1">
      <h2>{{ entity.fieldTitle }}</h2>
      <ul class="items cul">
        <li v-for="(item, index) in items" :key="index">
          <div class="time text-xsmall">
            {{ item.time }}
          </div>
          <div class="content">
            <h3>{{ item.title }}</h3>
            <div v-if="item.text" v-html="item.text" />
          </div>
        </li>
      </ul>
    </div>
  </Section>
</template>
<style scoped lang="scss">
.items {
  li {
    padding: 24px 0;
    border-bottom: 1px solid var(--c-line-light);
    display: grid;
    grid-template-columns: 100%;
    @include breakpoint(ts) {
      grid-template-columns: 1fr 4fr;
    }
    h3 {
      margin-bottom: 12px;
    }
    :deep(.content div *) {
      margin: 0;
    }
    .time {
      color: var(--c-primary);
      font-weight: bold;
    }
  }
}
</style>
